import React from 'react';
import './VerticalSpacer.css';

type VerticalSpacerProps = {
	spacing?: string;
	mobileSpacing?: string;
	direction?: 'top' | 'bottom';
};

export const VerticalSpacer = ({ spacing = '1rem', mobileSpacing, direction }: VerticalSpacerProps) => {
	const className = [
		'vertical-spacer',
		mobileSpacing ? 'responsive' : '',
		direction === 'top' ? 'spacer-top' : '',
		direction === 'bottom' ? 'spacer-bottom' : '',
		!direction ? 'spacer-both' : '',
	]
		.filter(Boolean)
		.join(' ');

	const data = {
		'--spacing': spacing,
		'--mobile-spacing': mobileSpacing || spacing,
	} as React.CSSProperties;

	return <div className={className} style={data} />;
};
